import React from 'react';
import PropTypes from 'prop-types';

// Pill tab bar: All / Revenue base / Guarantee / Bonuses / Merch rates /
// Taxes / Ancillary / Notes. The active tab gets a card-style highlight.
// Each tab shows its X/Y count chip on the right.
const V3DealTermsTabs = ({ sections, activeKey, onChange, ctx }) => {
  const total = sections.reduce((acc, s) => acc + s.items.length, 0);
  const configured = sections.reduce(
    (acc, s) => acc + s.items.filter((it) => it.isConfigured(ctx)).length,
    0,
  );

  return (
    <div className="deal-terms-tabs" role="tablist">
      <button
        type="button"
        role="tab"
        aria-selected={activeKey === 'all'}
        className={`deal-terms-tabs__tab ${activeKey === 'all' ? 'deal-terms-tabs__tab--active' : ''}`}
        onClick={() => onChange('all')}
      >
        <i className="fal fa-sliders-h deal-terms-tabs__tab-icon" aria-hidden="true" />
        <span className="deal-terms-tabs__tab-label">All</span>
        <span className="deal-terms-tabs__tab-count">{total}</span>
      </button>

      {sections.map((s) => {
        const itemTotal = s.items.length;
        const itemConfigured = s.items.filter((it) => it.isConfigured(ctx)).length;
        const isActive = activeKey === s.key;
        return (
          <button
            key={s.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`deal-terms-tabs__tab ${isActive ? 'deal-terms-tabs__tab--active' : ''}`}
            onClick={() => onChange(s.key)}
            data-testid={`deal-terms-tab-${s.key}`}
          >
            <i className={`${s.icon} deal-terms-tabs__tab-icon`} aria-hidden="true" />
            <span className="deal-terms-tabs__tab-label">{s.title}</span>
            <span className="deal-terms-tabs__tab-count">{itemConfigured}/{itemTotal}</span>
          </button>
        );
      })}

      {/* configured marker — used only by tests / not shown */}
      <span data-testid="deal-terms-tabs-totals" data-total={total} data-configured={configured} />
    </div>
  );
};

V3DealTermsTabs.propTypes = {
  sections: PropTypes.array.isRequired,
  activeKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  ctx: PropTypes.object.isRequired,
};

export default V3DealTermsTabs;
